/* src/app/common/components/lumi/lumi-chat/lumi-chat.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
}
.stagger-item {
  opacity: 0;
  animation: chatFadeInUp 200ms ease-out forwards;
  animation-delay: var(--anim-delay, 0ms);
}
@keyframes chatFadeInUp {
  from {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.return-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  padding-left: 1rem;
  flex-shrink: 0;
}
.return-title .return-icon {
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.return-title .return-icon ::ng-deep svg-icon svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.return-title .return-icon ::ng-deep app-centrui-icon {
  display: flex;
  align-items: center;
}
.return-title .return-icon ::ng-deep svg-icon {
  display: flex;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
}
.return-title .return-icon ::ng-deep svg-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.return-title .return-icon ::ng-deep svg-icon svg path {
  fill: #1E31BF !important;
}
.return-title span {
  font-family: "PoppinsSemi Bold";
  font-size: 1rem;
  line-height: 1.25rem;
  color: #1E31BF !important;
}
.lumi-chat {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.lumi-chat .lumi-chat-messages-wrapper {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-messages {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  overflow-y: auto;
  padding-right: 0.25rem;
}
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-messages::-webkit-scrollbar {
  width: 0.25rem;
}
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-messages::-webkit-scrollbar-thumb {
  background: #1E31BF;
  border-radius: 0.25rem;
}
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-messages.hide-scrollbar {
  overflow-y: hidden;
}
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-loading-older,
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-loading-history {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
}
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-loading-history {
  flex: 1;
  align-items: center;
}
.lumi-chat .lumi-chat-messages-wrapper .lumi-chat-messages-blur {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  background: rgba(255, 255, 255, 0.15);
  z-index: 1;
  animation: chatFadeInUp 200ms ease-out forwards;
}
.lumi-chat .lumi-chat-input-wrapper {
  padding: 1rem;
  flex-shrink: 0;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  border: none;
  border-radius: 0.5rem;
  padding: 0.875rem 1rem;
  background: #F5F7FA;
  border: 1px solid #EBEBEB;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input textarea {
  flex: 1;
  border: none;
  outline: none;
  font-family: "PoppinsRegular";
  font-size: 0.875rem;
  color: #757575;
  background: transparent;
  resize: none;
  overflow-y: hidden;
  height: 1.25rem;
  max-height: 6.25rem;
  line-height: 1.25rem;
  padding: 0;
  margin: 0;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input textarea::-webkit-scrollbar {
  width: 0.25rem;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input textarea::-webkit-scrollbar-thumb {
  background: #1E31BF;
  border-radius: 0.25rem;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input textarea::-webkit-scrollbar-track {
  background: transparent;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input textarea::placeholder {
  color: #757575;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input .lumi-chat-send-btn {
  background: none;
  border: none;
  padding: 0;
  margin-top: 0;
  cursor: pointer;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input .lumi-chat-send-btn ::ng-deep svg-icon svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input .lumi-chat-send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input .lumi-chat-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input .lumi-chat-send-btn ::ng-deep svg-icon svg path {
  transition: fill 300ms ease-in-out;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input .lumi-chat-send-btn:not(:disabled):hover ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input .lumi-chat-send-btn:not(:disabled):hover ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #1E31BF !important;
}
.lumi-chat .lumi-chat-input-wrapper .lumi-chat-input .lumi-chat-send-btn:not(:disabled):hover ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #1E31BF !important;
}
.lumi-chat .lumi-chat-feedback-overlay {
  padding: 0 1rem;
  flex-shrink: 0;
  animation: chatFadeInUp 200ms ease-out forwards;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input {
  background: #F5F7FA;
  border: 1px solid #EBEBEB;
  border-radius: 0.5rem;
  padding: 0.875rem 1rem;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input textarea {
  width: 100%;
  border: none;
  outline: none;
  font-family: "PoppinsRegular";
  font-size: 0.875rem;
  color: #757575;
  background: transparent;
  resize: none;
  line-height: 1.25rem;
  padding: 0;
  margin: 0;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input textarea::placeholder {
  color: #757575;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-divider {
  border: none;
  border-top: 1px solid #EBEBEB;
  margin: 0.5rem 0;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions .lumi-chat-feedback-send-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions .lumi-chat-feedback-send-btn ::ng-deep svg-icon svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions .lumi-chat-feedback-send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions .lumi-chat-feedback-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions .lumi-chat-feedback-send-btn ::ng-deep svg-icon svg path {
  transition: fill 300ms ease-in-out;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions .lumi-chat-feedback-send-btn:not(:disabled):hover ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions .lumi-chat-feedback-send-btn:not(:disabled):hover ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #1E31BF !important;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-input .lumi-chat-feedback-overlay-actions .lumi-chat-feedback-send-btn:not(:disabled):hover ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #1E31BF !important;
}
.lumi-chat .lumi-chat-feedback-overlay .lumi-chat-feedback-overlay-note {
  font-family: "PoppinsRegular";
  font-size: 0.65rem;
  line-height: 0.75rem;
  text-align: justify;
  color: #AAAAAA;
  margin-top: 0.5rem;
}
/*# sourceMappingURL=lumi-chat.component.css.map */
